import { Collapse } from '@material-ui/core';

import {
  ConfidenceWebsiteLink,
  useDisplayNames,
} from '@spotify/confidence-core-react';

import { AggregationTypeSelect } from '../AggregationTypeSelect';
import { useAggregatedMeasurement } from './context';

export type TypeProps = {
  label?: string;
  'data-testid'?: string;
};

export const Type = ({ label, 'data-testid': testId }: TypeProps) => {
  const {
    measurement,
    aggregationType,
    entity,
    enabledAggregationTypes,
    onAggregationTypeChange,
  } = useAggregatedMeasurement();
  const { displayNames } = useDisplayNames();
  const entityName = displayNames.get(entity) || 'entity';

  return (
    <Collapse in={!!measurement?.name} unmountOnExit>
      <AggregationTypeSelect
        label={label}
        data-testid={testId}
        entityName={entityName}
        measurementName={measurement?.name}
        value={aggregationType}
        enabledOptions={enabledAggregationTypes}
        onChange={onAggregationTypeChange}
        helperText={
          <>
            How to aggregate {measurement?.name || 'the measurement'} per{' '}
            {entityName}.{' '}
            <ConfidenceWebsiteLink
              route="/docs/metrics#within-entity-aggregation"
              underline="always"
             data-track-source-anchor="9214d9e034">
              Learn more.
            </ConfidenceWebsiteLink>
          </>
        }
       data-track-source-anchor="87ab23c24d;type-aggregation-type-select"/>
    </Collapse>
  );
};
